import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "services/locale/momentInit.js";

import { Button, Form } from "react-bootstrap";

import conxtdOut from "apis/conxtdOut";

import {
  loadSiteViewStart,
  loadSiteViewCancel, 
  loadSiteViewLiveRefreshStart, 
  loadSiteViewLiveRefreshCancel,
  setSiteViewRefreshCount,
} from "services/redux/actions";

import {
  loadSingleSiteViewStart,
  loadSingleSiteViewCancel,
} from "services/redux/actions/singleSites";

import { createGetEventMetaById } from "services/redux/selectors/eventMeta";
import Alert from "components/Common/Alert";

class Comments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: "",
    };

    this.clearData = this.clearData.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }
  clearData() {
    this.setState({
      text: "",
    });
  }

  changeHandler = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  submitHandler = async (e) => {
    e.preventDefault();
    const { loggedInUser, site, origin } = this.props;

    const siteId = site.id;
    const fullName = loggedInUser.firstName + " " + loggedInUser.lastName;

    const event = "C150";
    const zone = "";
    const text = fullName + " - " + e.target.text.value;
    const time = moment.utc().format();

    try {
      const url = origin === "SingleSite" ? "/single-sites/add-comment/" : "/Events/add/";

      await conxtdOut.post(`${url}${siteId}`, {
        event,
        zone,
        text,
        comment: text, // the single site endpoint accepts 'comment' instead of 'text' - just pass them both
        time,
      });
      this.setState({
        comment: "",
        text2: "",
        text: "",
        time: "",
      });

      Alert({
        text: "Comment has been submitted.",
        icon: "success",
        timer: 4000,
        timerProgressBar: true,
        // showConfirmButton: false,
      });

      setTimeout(() => {
        if (origin === "SiteList") {
          // Cancel previous
          this.props.dispatch(loadSiteViewCancel());
    
          this.props.dispatch(
            loadSiteViewStart({
              origin: origin,
              id: site.id,
              timeframe: site.timeframe
            })
          );
        } else if (origin === "SingleSite") {
          // Cancel previous
          this.props.dispatch(loadSingleSiteViewCancel());
    
          this.props.dispatch(
            loadSingleSiteViewStart({
              sudo_site_id: site.id,
              timeframe: site.timeframe
            })
          );
        } else {
          // Cancel previous
          this.props.dispatch(
            loadSiteViewLiveRefreshCancel()
          );
    
          this.props.dispatch(
            setSiteViewRefreshCount({
              refreshCount: 0
            })
          );
    
          this.props.dispatch(
            loadSiteViewLiveRefreshStart({
              origin: origin,
              id: site.id,
              timeframe: site.timeframe
            })
          );
        }
      }, 3000);
    } catch (error) {
      console.log("Error details", error);
    }
  };

  onCancel(e) {
    e.preventDefault();
    this.clearData();
  }

  render() {
    return (
      <Form onSubmit={this.submitHandler}>
        <Form.Group controlId="exampleForm.ControlTextarea1">
          <div>
            <h6>Comments</h6>
            Ability to add comment events into site timeline. <br></br>
            Please note:
            <ul>
              <li>
                Anyone who has access to the site will be able to view the
                comment. This could be end user and installer.
              </li>
              <li>Users name will appear before each comment.</li>
            </ul>
            Comments can be received as notifications if users have all events
            enabled or CONXTD reminders. <br></br> <br></br>
            <p>
              <a
                href={`https://intercom.help/conxtd/en/articles/4191380-comment-events`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button>Learn More</Button>
              </a>
            </p>
          </div>
          <Form.Control
            as="textarea"
            rows="6"
            required
            type="text"
            name="text"
            placeholder="Add your comment here..."
            onChange={this.changeHandler}
            maxLength="300"
            value={this.state.text}
          />
        </Form.Group>
        <Button
          //  disabled={loading}
          type="submit"
          variant="success"
          className="float-right"
          style={{ height: "30%", width: "30%", marginBottom: "90px" }}
        >
          {/*    {loading && <Loading />} */}
          Submit Comment
        </Button>{" "}
        <Button
          variant="primary"
          className="float-left"
          style={{ height: "30%", width: "30%" }}
          onClick={this.onCancel}
        >
          Clear Comment
        </Button>
      </Form>
    );
  }
}
const mapStateToProps = (state, props) => {
  return {
    loggedInUser: state.user,
    users: state.users,
    getEventMetaById: createGetEventMetaById(state, props),
  };
};

export default connect(mapStateToProps, null)(Comments);
